module.exports = __webpack_public_path__ + "media/images/logo/LOGO OJK-17dadaf64b89aa0d4e387b96bf7bc784.png";